import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Download, Share2 } from 'lucide-react';
import { Button } from './ui.js';
import { useToast } from './Toast.js';

export const APP_DOWNLOAD_URL = 'https://play.google.com/store/apps/details?id=il.co.worki.app';

export function AppDownloadCard() {
  const { t } = useTranslation();
  const toast = useToast();
  const [qr, setQr] = useState('');
  useEffect(() => {
    let active = true;
    void import('qrcode').then(({ default: QRCode }) => QRCode.toDataURL(APP_DOWNLOAD_URL, { margin: 4, errorCorrectionLevel: 'M', width: 192 }))
      .then(url => { if (active) setQr(url); }).catch(() => undefined);
    return () => { active = false; };
  }, []);
  const share = async () => {
    try {
      if (navigator.share) await navigator.share({ title: t('completion.download'), url: APP_DOWNLOAD_URL });
      else { await navigator.clipboard.writeText(APP_DOWNLOAD_URL); toast.success(t('completion.copied')); }
    } catch (error) { if (!(error instanceof DOMException && error.name === 'AbortError')) toast.error(t('errors.unknown')); }
  };
  return <section className="rounded-2xl border border-border bg-card p-4 flex flex-col items-center gap-3 sm:flex-row" aria-label={t('completion.download')}>
    {qr && <img src={qr} width={144} height={144} alt={t('completion.download')} className="rounded-lg bg-white shrink-0" />}
    <div className="space-y-3 min-w-0"><h2 className="font-bold">{t('completion.download')}</h2><p className="text-sm text-muted-foreground">{t('completion.downloadHint')}</p>
      <a href={APP_DOWNLOAD_URL} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-sm text-primary break-all"><Download className="h-4 w-4 shrink-0" /><span>{APP_DOWNLOAD_URL}</span></a>
      <Button type="button" icon={<Share2 className="h-4 w-4" />} onClick={() => void share()}>{t('completion.shareDownload')}</Button>
    </div>
  </section>;
}
